export class TranslationDto {
  locale?: string;
  name: string;
  description: string;
  value: string;

  constructor(d?: TranslationDto) {
    if (!d) {
      return;
    }
    this.locale = d.locale;
    this.name = d.name;
    this.description = d.description;
    this.value = d.value;
  }
}
